import { Component } from 'react';

export class SwitchIconSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                data-testid={this.props['data-testid']}
                className={className}
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.537 15H1.002C.332 15-.002 14.667 0 14c.002-.666.335-1 1-1h15.467l-1.137-1.137a1 1 0 0 1 1.414-1.414l2.879 2.879a1 1 0 0 1 0 1.414l-2.88 2.88a1 1 0 1 1-1.414-1.414L16.536 15ZM3.607 3H19c.667-.003 1 .33 1 1.002 0 .671-.333 1.004-1 .998H3.537l1.207 1.208A1 1 0 1 1 3.33 7.622L.45 4.742a1 1 0 0 1 0-1.414L3.329.449a1 1 0 1 1 1.414 1.414L3.606 3Z"
                    fill="#08172B"
                />
            </svg>
        );
    }
}
